import _regeneratorRuntime from "/Users/everton/Laev/ike-novolayout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { cloneNode } from './cloneNode';
import { embedImages } from './embedImages';
import { applyStyleWithOptions } from './applyStyleWithOptions';
import { embedWebFonts, getWebFontCSS } from './embedWebFonts';
import { getNodeWidth, getNodeHeight, getPixelRatio, createImage, canvasToBlob, nodeToDataURL } from './util';

function getImageSize(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var width = options.width || getNodeWidth(node);
  var height = options.height || getNodeHeight(node);
  return {
    width: width,
    height: height
  };
}

export function toSvg(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getImageSize, width, height;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getImageSize = getImageSize(node, options), width = _getImageSize.width, height = _getImageSize.height;
            return _context.abrupt("return", Promise.resolve(node).then(function (nativeNode) {
              return cloneNode(nativeNode, options, true);
            }).then(function (clonedNode) {
              return embedWebFonts(clonedNode, options);
            }).then(function (clonedNode) {
              return embedImages(clonedNode, options);
            }).then(function (clonedNode) {
              return applyStyleWithOptions(clonedNode, options);
            }).then(function (clonedNode) {
              return nodeToDataURL(clonedNode, width, height);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
var dimensionCanvasLimit = 16384; // as per https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size

function checkCanvasDimensions(canvas) {
  if (canvas.width > dimensionCanvasLimit || canvas.height > dimensionCanvasLimit) {
    if (canvas.width > dimensionCanvasLimit && canvas.height > dimensionCanvasLimit) {
      if (canvas.width > canvas.height) {
        canvas.height *= dimensionCanvasLimit / canvas.width;
        canvas.width = dimensionCanvasLimit;
      } else {
        canvas.width *= dimensionCanvasLimit / canvas.height;
        canvas.height = dimensionCanvasLimit;
      }
    } else if (canvas.width > dimensionCanvasLimit) {
      canvas.height *= dimensionCanvasLimit / canvas.width;
      canvas.width = dimensionCanvasLimit;
    } else {
      canvas.width *= dimensionCanvasLimit / canvas.height;
      canvas.height = dimensionCanvasLimit;
    }
  }
}

export function toCanvas(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", toSvg(node, options).then(createImage).then(function (img) {
              var canvas = document.createElement('canvas');
              var context = canvas.getContext('2d');
              var ratio = options.pixelRatio || getPixelRatio();

              var _getImageSize2 = getImageSize(node, options),
                  width = _getImageSize2.width,
                  height = _getImageSize2.height;

              var canvasWidth = options.canvasWidth || width;
              var canvasHeight = options.canvasHeight || height;
              canvas.width = canvasWidth * ratio;
              canvas.height = canvasHeight * ratio;

              if (!options.skipAutoScale) {
                checkCanvasDimensions(canvas);
              }

              canvas.style.width = "".concat(canvasWidth);
              canvas.style.height = "".concat(canvasHeight);

              if (options.backgroundColor) {
                context.fillStyle = options.backgroundColor;
                context.fillRect(0, 0, canvas.width, canvas.height);
              }

              context.drawImage(img, 0, 0, canvas.width, canvas.height);
              return canvas;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function toPixelData(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _getImageSize3, width, height;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getImageSize3 = getImageSize(node, options), width = _getImageSize3.width, height = _getImageSize3.height;
            return _context3.abrupt("return", toCanvas(node, options).then(function (canvas) {
              var ctx = canvas.getContext('2d');
              return ctx.getImageData(0, 0, width, height).data;
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}
export function toPng(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", toCanvas(node, options).then(function (canvas) {
              return canvas.toDataURL();
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}
export function toJpeg(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", toCanvas(node, options).then(function (canvas) {
              return canvas.toDataURL('image/jpeg', options.quality || 1);
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}
export function toBlob(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", toCanvas(node, options).then(canvasToBlob));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}
export function getFontEmbedCSS(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", getWebFontCSS(node, options));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
}